module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.amazon.title":"AWS Cloud Connections","settings.amazon.subtitle":"All cloud connections importing AWS usage data in this tenant.","settings.amazon.editNew":"Edit Assume Role Credentials","settings.amazon.editLegacy":"Edit IAM Access Key Credentials","copy cloud connection":"Copy Cloud Connection"}}')
  delete Component.options._Ctor
}
